import request from '../../utils/request'

// 获取分页

export function getMaterialList(data) {
  return request({
    url: '/sc/ticketMain/api/factYdclZb/page',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 获取机构列表
export function getJgList(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/listAll',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 获取明细列表
export function getMaterialDetailList(data) {
  return request({
    url: '/sc/ticketMain/api/factYdclmx/page',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 附件证明上传
export function getUploadFjzmFile(data) {
  return request({
    url: '/sc/ticketMain/api/factYdclZb/uploadFjzmFile',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
      isToken: true
    }
  })
}

// 统计表上传
export function getUploadTjbFile(data) {
  return request({
    url: '/sc/ticketMain/api/factYdclZb/uploadTjbFile',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
      isToken: true
    }
  })
}

// 预兑材料明细导入
export function getExcelRead(data) {
  return request({
    url: '/sc/ticketMain/api/factYdclmx/excelRead',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
      isToken: true
    }
  })
}

// 新增或修改预兑材料
export function getSaveOrUpdate(data) {
  return request({
    url: '/sc/ticketMain/api/factYdclZb/saveOrUpdate',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}

// 删除预兑材料明细
export function getFactYdclmxDelete(params) {
  return request({
    url: '/sc/ticketMain/api/factYdclmx/delete',
    method: 'get',
    params: params,
    headers: {
      isToken: true
    }
  })
}

// 删除预兑材料明细
export function getTabStatistics(params) {
  return request({
    url: '/sc/ticketMain/api/factYdclZb/tabStatistics',
    method: 'get',
    params: params,
    headers: {
      isToken: true
    }
  })
}
